import { render, staticRenderFns } from "./ResimpleSwitch.vue?vue&type=template&id=4c241252&"
import script from "./ResimpleSwitch.vue?vue&type=script&lang=js&"
export * from "./ResimpleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ResimpleSwitch.vue?vue&type=style&index=0&id=4c241252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports